const permitir_numerar_o_diario_de_classe = {
  path: "/permitir-numerar-o-diario-de-classe",
  redirect: "/permitir-numerar-o-diario-de-classe",
  meta: {
    breadCrumb: "Processo de Matrículas - Diário de Classe da Turma",
  },
  children: [
    {
      path: "/permitir-numerar-o-diario-de-classe",
      name: "permitir_numerar_o_diario_de_classe",
      component: () =>
        import(
          "@/views/PermitirNumerarDiarioDeClasse/PermitirNumerarDiarioDeClasse.vue"
        ),
    },
    {
      path: "/permitir-numerar-o-diario-de-classe/turma/:turma_id/ano-matricula/:ano_matricula/sequencial/:sequencial/escola/:escola_id",
      name: "permitir_numerar_o_diario_de_classe_editar",
      component: () =>
        import(
          "@/views/PermitirNumerarDiarioDeClasse/PermitirNumerarDiarioDeClasseEditar.vue"
        ),
    },
  ],
};

export { permitir_numerar_o_diario_de_classe };
